import { Box, Flex } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import { ContentfulTags } from '@enums/ContentfulTags';
import AllPosts from './AllPosts';
import Popular from './Popular';

const FEATURED_COUNT = 3;

const ArticlesIndex = ({ posts }) => {
  let featured = posts.filter((post) => post.contentfulTags.includes(ContentfulTags.FEATURED));
  const standard = posts.filter((post) => !post.contentfulTags.includes(ContentfulTags.FEATURED));

  // If there are less featured posts than the FEATURED_COUNT, append standard posts
  if (featured.length < FEATURED_COUNT) {
    featured = featured.concat(standard.slice(0, FEATURED_COUNT - featured.length));
  }

  return (
    <DefaultLayout>
      <Box w="100%" px={antlerStyle.px} pt={[6, 6, 12]} pb={[6, 6, 8]}>
        <Flex w="100%" maxW="1200px" mx="auto">
          <Header as="h2" textAlign="center" w="100%">
            The Fair Square Blog
          </Header>
        </Flex>
      </Box>
      <Box w="100%" px={antlerStyle.px}>
        <Flex maxW="1200px" mx="auto">
          <Popular featuredPosts={featured.slice(0, 3)} />
        </Flex>
      </Box>
      <Box pb={30}>
        <AllPosts posts={posts} />
      </Box>
    </DefaultLayout>
  );
};

export default ArticlesIndex;
